import styles from "../../styles/alert_popup.module.css";

const AlertTemplate = ({ message }) => (
  <div className={styles.alert_popup_cont}>{message}</div>
);

export default AlertTemplate;
